import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "UserFavorite"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.4774 9.00001C19.9391 8.99973 19.4234 9.21596 19.0464 9.60001L18.7516 9.90151L18.4539 9.59926C18.0766 9.21558 17.561 8.99949 17.0229 8.99949C16.4847 8.99949 15.9692 9.21558 15.5919 9.59926C14.8023 10.4045 14.8023 11.6935 15.5919 12.4988L18.7516 15.6968L21.9084 12.4988C22.6979 11.6935 22.6979 10.4045 21.9084 9.59926C21.5312 9.21549 21.0155 8.99953 20.4774 9.00001ZM1.5 22.5H3V18.75C3.00248 16.68 4.67996 15.0025 6.75 15H11.25C13.32 15.0025 14.9975 16.68 15 18.75V22.5H16.5V18.75C16.4967 15.8519 14.1481 13.5033 11.25 13.5H6.75C3.85188 13.5033 1.50331 15.8519 1.5 18.75V22.5ZM9 3C11.0711 3 12.75 4.67893 12.75 6.75C12.75 8.82107 11.0711 10.5 9 10.5C6.92893 10.5 5.25 8.82107 5.25 6.75C5.25 4.67893 6.92893 3 9 3ZM9 1.5C6.1005 1.5 3.75 3.85051 3.75 6.75C3.75 9.6495 6.1005 12 9 12C11.8995 12 14.25 9.6495 14.25 6.75C14.25 3.85051 11.8995 1.5 9 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/UserFavorite.vue"]]);
